import i18n from '@/plugins/i18n';

const elastiCacheCharts = () => ({
  lineChartsOverviewPage: [
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.swapUsageInMb'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_eca_host_swap_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        y: i18n.global.t('aws.sizeInMb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1048576',
      aggregationType: 'sum',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.clusterCount'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_eca_host_cluster_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'avg',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.nodeCount'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_eca_host_node_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'sum',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.memoryAvailable'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_eca_host_memory_available',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        y: i18n.global.t('aws.sizeInMb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1048576',
      aggregationType: 'sum',
    },
  ],
  host: [
    {
      // metricName: 'cluster_eca_host_each_cluster_node_count',
      metricName: 'cluster_eca_host_each_cluster_node_count',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      header: {
        title: i18n.global.t('aws.nodeCount'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_host_memory_available',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.sizeInMb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1048576',
      header: {
        title: i18n.global.t('aws.memoryAvailable'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_host_network_bytes_out',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.sizeInMb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1048576',
      header: {
        title: i18n.global.t('aws.networkBytesOut'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_host_swap_usage',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.sizeInMb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1048576',
      header: {
        title: i18n.global.t('aws.swapUsageByCluster'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_host_cpu_utilization',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.nodes'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value / 10000).toFixed(3),
      formulaName: 'aggregateBy10000',
      title: i18n.global.t('aws.cpuUtilizationByNode'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.percentage'),
      },
    },
    {
      metricName: 'cluster_eca_host_network_bytes_in',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.sizeInMb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1048576',
      header: {
        title: i18n.global.t('aws.networkBytesInByCluster'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
  ],
  redis: [
    {
      metricName: 'cluster_eca_redis_engine_cpu_utilization_by_node',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.nodes'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value / 10000).toFixed(3),
      formulaName: 'aggregateBy10000',
      title: i18n.global.t('aws.engineCPUUtilization'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.percentage'),
      },
    },
    {
      metricName: 'cluster_eca_redis_cache_misses_by_node',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.nodes'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.cacheMisses'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'cluster_eca_redis_cpu_utilization',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.percentage'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '10000',
      header: {
        title: i18n.global.t('aws.cpuUtilizationByCluster'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_redis_database_memory_usage_percentage',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.percentage'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '10000',
      header: {
        title: i18n.global.t('aws.databaseMemoryUsage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_redis_replication_bytes',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.sizeInMb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      header: {
        title: i18n.global.t('aws.replicationBytes'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_redis_new_connections',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      header: {
        title: i18n.global.t('aws.newConnections'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_redis_bytes_used_for_cache_by_node',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.nodes'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value / 1048576).toFixed(3),
      formulaName: 'toMB',
      title: i18n.global.t('aws.bytesUsedForCache'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.sizeInMb'),
      },
    },
    {
      metricName: 'cluster_eca_redis_cache_hit_rate_by_node',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.nodes'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.cacheHitRate'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'cluster_eca_redis_evictions',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      header: {
        title: i18n.global.t('aws.evictionsByClusters'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_redis_current_connections',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      header: {
        title: i18n.global.t('aws.currentConnections'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
  ],
  memcached: [
    {
      metricName: 'cluster_eca_memc_current_connections',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      header: {
        title: i18n.global.t('aws.currentConnections'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_memc_get_commands',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      header: {
        title: i18n.global.t('aws.getCommandsByCluster'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_memc_set_commands',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      header: {
        title: i18n.global.t('aws.setCommandsByCluster'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_memc_config_get_commands',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      header: {
        title: i18n.global.t('aws.configGetCommands'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_memc_config_set_commands',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      header: {
        title: i18n.global.t('aws.configSetCommands'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_memc_new_connections',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      header: {
        title: i18n.global.t('aws.newConnections'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_memc_evictions',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      header: {
        title: i18n.global.t('aws.evictionsByClusters'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_memc_cpu_utilization',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.percentage'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '10000',
      header: {
        title: i18n.global.t('aws.cpuUtilizationByCluster '),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      isMultiMetric: false,
      entityType: 'Service',
      formula: (value) => parseFloat(value).toFixed(3),
    },
    {
      metricName: 'cluster_eca_memc_bytes_used_for_hash',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.nodes'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value / 1048576).toFixed(3),
      formulaName: 'toMB',
      title: i18n.global.t('aws.bytesUsedForHash'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.sizeInMb'),
      },
    },
    {
      metricName: 'cluster_eca_memc_cas_hit_rate_by_node',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.nodes'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.casHitRate'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'cluster_eca_memc_get_command_by_node',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.nodes'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.getCommandsByNode'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'cluster_eca_memc_set_command_by_node',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.nodes'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.setCommandsByNode'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'cluster_eca_memc_cache_miss_rate_by_node',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.nodes'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.casMissRate'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
  ],
});

export default elastiCacheCharts;

// const elastiCacheCharts = () => ({
//   linechartsOverviewPage: [
//     {
//       width: '49%',
//       header: {
//         title: i18n.global.t('aws.healthyHostCount'),
//         content: [],
//         HideCenterMiscContent: true,
//       },
//       chartColor: ['#2F91EC'],
//       height: '12.5em',
//       entityType: 'Service',
//       independentSelector: false,
//       metricType: 'LABELED_VALUE',
//       metricName: 'service_elb_healthy_host_count',
//       queryMetricType: 'readMetricsValues',
//       childQueries: [],
//       chartType: 'ApexChartLine',
//       axisLabels: {},
//       showLegendForSeries: true,
//       aggregation: '/',
//       aggregationNum: '1',
//       aggregationType: 'sum',
//     },
//     {
//       width: '49%',
//       header: {
//         title: i18n.global.t('aws.unhealthyHostCount'),
//         content: [],
//         HideCenterMiscContent: true,
//       },
//       chartColor: ['#2F91EC'],
//       height: '12.5em',
//       entityType: 'Service',
//       independentSelector: false,
//       metricType: 'LABELED_VALUE',
//       metricName: 'service_elb_unhealthy_host_count',
//       queryMetricType: 'readMetricsValues',
//       childQueries: [],
//       chartType: 'ApexChartLine',
//       axisLabels: {},
//       showLegendForSeries: true,
//       aggregation: '/',
//       aggregationNum: '1',
//       aggregationType: 'sum',
//     },
//     {
//       width: '49%',
//       header: {
//         title: i18n.global.t('aws.avgRequests'),
//         content: [],
//         HideCenterMiscContent: true,
//       },
//       chartColor: ['#2F91EC'],
//       height: '12.5em',
//       entityType: 'Service',
//       independentSelector: false,
//       metricType: 'LABELED_VALUE',
//       metricName: 'service_elb_average_request_count',
//       queryMetricType: 'readMetricsValues',
//       childQueries: [],
//       chartType: 'ApexChartLine',
//       axisLabels: {},
//       showLegendForSeries: true,
//       aggregation: '/',
//       aggregationNum: '1',
//       aggregationType: 'sum',
//     },
//     {
//       width: '49%',
//       header: {
//         title: i18n.global.t('aws.avgResponseTime'),
//         content: [],
//         HideCenterMiscContent: true,
//       },
//       chartColor: ['#2F91EC'],
//       height: '12.5em',
//       entityType: 'Service',
//       independentSelector: false,
//       metricType: 'LABELED_VALUE',
//       metricName: 'service_elb_average_response_time',
//       queryMetricType: 'readMetricsValues',
//       childQueries: [],
//       chartType: 'ApexChartLine',
//       axisLabels: {},
//       showLegendForSeries: true,
//       aggregation: '/',
//       aggregationNum: '1',
//       aggregationType: 'sum',
//     },
//     {
//       width: '49%',
//       header: {
//         title: i18n.global.t('aws.totalInstance'),
//         content: [],
//         HideCenterMiscContent: true,
//       },
//       chartColor: ['#2F91EC'],
//       height: '12.5em',
//       entityType: 'Service',
//       independentSelector: false,
//       metricType: 'LABELED_VALUE',
//       metricName: 'service_elb_instance_count',
//       queryMetricType: 'readMetricsValues',
//       childQueries: [],
//       chartType: 'ApexChartLine',
//       axisLabels: {},
//       showLegendForSeries: true,
//       aggregation: '/',
//       aggregationNum: '1',
//       aggregationType: 'sum',
//     },
//   ],
//   lineChartsALB: [
//     {
//       metricName: 'elb_alb_total_request_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.totalRequestCount'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_alb_target_response_time',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.targetResponseTime'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.timeInMicroSecond'),
//       },
//     },
//     {
//       metricName: 'elb_alb_total_request_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.callsPerMinute'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.countPerMin'),
//       },
//     },
//     {
//       metricName: 'elb_alb_errors',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.errorsPerMinute'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.countPerMin'),
//       },
//     },
//     {
//       metricName: 'elb_alb_rejected_request_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.rejectedRequests'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_alb_http_fixed_response_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.httpFixedResponseCount'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_alb_4xx_errors',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.http4xxErrors'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_alb_5xx_errors',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.http5xxErrors'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_alb_active_connection_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.totalActiveConnections'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_alb_processed_bytes',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.totalProcessedBytesCount'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_alb_2xx_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.http2xxCount'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_alb_3xx_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.http3xxCount'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//   ],
//   lineChartsNLB: [
//     {
//       metricName: 'elb_nlb_rejected_request_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.rejectedRequests'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_nlb_errors',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.errorsPerMinute'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.countPerMin'),
//       },
//     },
//     {
//       metricName: 'elb_nlb_port_allocation_error',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.portAllocationErrors'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_nlb_client_tls_negotiation_error_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.clientTlsNegotiationErrors'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_nlb_active_flow_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.totalActiveConnections'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_nlb_processed_bytes',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.totalProcessedBytesCount'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_nlb_target_tls_negotiation_error_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.targetNegotiationErrors'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//   ],
//   lineChartsCLB: [
//     {
//       metricName: 'elb_clb_total_request_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.totalRequestCount'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_clb_latency',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.latency'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.timeInMicroSecond'),
//       },
//     },
//     {
//       metricName: 'elb_clb_total_request_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.callsPerMinute'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.countPerMin'),
//       },
//     },
//     {
//       metricName: 'elb_clb_errors',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.errorsPerMinute'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.countPerMin'),
//       },
//     },
//     {
//       metricName: 'elb_clb_4xx_errors',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.http4xxErrors'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_clb_5xx_errors',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.http5xxErrors'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_clb_active_connection_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.totalActiveConnections'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_clb_estimated_processed_bytes',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.totalProcessedBytesCount'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_clb_2xx_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.http2xxCount'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//     {
//       metricName: 'elb_clb_3xx_count',
//       queryMetricType: 'readMetricsValues',
//       valueColumn: 'value',
//       width: '49%',
//       headers: [
//         {
//           label: i18n.global.t('alert.instances'),
//           width: '60%',
//           key: 'label',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.avg'),
//           width: '20%',
//           key: 'avg',
//           sortable: false,
//         },
//         {
//           label: i18n.global.t('aws.max'),
//           width: '20%',
//           key: 'max',
//           sortable: false,
//         },
//       ],
//       isMultiMetric: true,
//       entityType: 'ServiceInstance',
//       formula: (value) => parseFloat(value).toFixed(3),
//       title: i18n.global.t('aws.http3xxCount'),
//       graphTitles: {
//         x: i18n.global.t('aws.time'),
//         y: i18n.global.t('aws.count'),
//       },
//     },
//   ],
// });

// export default elastiCacheCharts;
